// Core
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { motion, useAnimation } from 'framer-motion';
import { Box, Checkbox, Image, Divider, Button, Grid, Text, Flex, Skeleton, useBreakpointValue, useColorModeValue } from '@chakra-ui/react';
import { NavLink, Link, useHistory, useLocation } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';
import { ReactComponent as PlusCategoryIcon } from 'assets/svg/show-category-parent.svg';

// Components
import { ArrowCategoryIcon } from 'components/Icons/Icons';

const States = ({ setSelectedStates, selectedStates }) => {
    const textColor = useColorModeValue('#0E1633', 'white');
    const borderBottom = useColorModeValue('1px solid #CBE7FF', '1px solid #262D47');

    const { data, isLoading } = useQuery({
        queryKey: ['partnerStates'],
        queryFn: async () => {
            const response = await apiService.getStates();
            return response.data;
        },
        refetchOnWindowFocus: false
    });

    const [collapsedItems, setCollapsedItems] = useState(false); 
    const toggleItems = () => {
        setCollapsedItems(!collapsedItems);
    };

    const responsiveSettings = useBreakpointValue({ base: true, md: false });
    useEffect(() => { setCollapsedItems(responsiveSettings); }, [responsiveSettings]);

    const resetStates = () => {
        setCollapsedItems(!collapsedItems);
    };

    const history = useHistory();
    const toggleTag = (id) => {
        let updatedStates = [...selectedStates];

        if (updatedStates.includes(id)) {
            updatedStates = updatedStates.filter(tag => tag !== id);
        } else {
            updatedStates.push(id);
        }

        setSelectedStates(updatedStates);

        const searchParams = new URLSearchParams(window.location.search);

        if (updatedStates.length > 0) {
            searchParams.set('locations', updatedStates.join(',')); 
        } else {
            searchParams.delete('locations'); 
        }

        history.push({ search: searchParams.toString() });
    };

    return (
    	<>
    	{ isLoading ? ( 
            <Skeleton height="40px" my="8px" borderRadius="16px" />
        ) : (
            <>
                <Flex alignItems="center" justifyContent="space-between" pt="10px">
                    <Text variant="text-md" color={textColor} fontWeight="500">
                        States
                    </Text>
                    <ArrowCategoryIcon 
                        fontSize="24px"
                        transition="0.2s all"
                        transform={ collapsedItems ? 'rotate(90deg)' : 'rotate(0deg)' } 
                        onClick={toggleItems} />
                </Flex>
            
                <Box 
                    maxH={ collapsedItems ? '0px' : '450px' } 
                    transition="0.2s all" 
                    overflowY={ collapsedItems ? 'hidden' : 'scroll'}
                    opacity={ collapsedItems ? '0' : '1'}
                    sx={{
                        '&::-webkit-scrollbar': { display: 'none' }, 
                        '-ms-overflow-style': 'none', 
                        'scrollbar-width': 'none',
                    }}
                    p="24px 12px 0 12px">
                    { data?.map((item, index) => (
                        <Flex key={index} w="100%" gap="12px" mb="17px" alignItems="center">
                            <Checkbox 
                                isChecked={selectedStates.includes(item)}
                                onChange={() => toggleTag(item)}
                                colorScheme="blue"
                            >
                                <Text 
                                    variant="text-sm"
                                    whiteSpace="nowrap"
                                    color={textColor}
                                    fontWeight="500"
                                    cursor="pointer"
                                >
                                    {item}
                                </Text>
                            </Checkbox>
                        </Flex>
                    ))}
                </Box>

                <Box borderTop={borderBottom} opacity={collapsedItems ? '0' : '1'} />
            </>
	    )}
	    </>
    );
};


export default States;